import React from "react";
import { useTranslation } from "react-i18next";
import "./DownloadBookModal.css";

const DownloadBookModal = ({ isOpen, onConfirm, onClose }) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <div className="download-book-modal-overlay" onClick={onClose}>
      <div
        className="download-book-modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="download-book-modal-header">
          <h3>{t("download_book_modal.title")}</h3>
        </div>

        <div className="download-book-modal-body">
          <div className="download-book-icon">
            <i className="fa-solid fa-download"></i>
          </div>
          <p className="download-book-message">
            {t("download_book_modal.message")}
          </p>
        </div>

        <div className="download-book-modal-footer">
          <button className="download-book-confirm-btn" onClick={onConfirm}>
            {t("download_book_modal.confirm_button")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DownloadBookModal;
